import { render, staticRenderFns } from "./report-more.vue?vue&type=template&id=fa652e74&scoped=true&"
import script from "./report-more.vue?vue&type=script&lang=js&"
export * from "./report-more.vue?vue&type=script&lang=js&"
import style0 from "./report-more.vue?vue&type=style&index=0&id=fa652e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa652e74",
  null
  
)

export default component.exports